import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./CarFeatures.scss";
import Select from "./Select";
import adesisServices from "../../../services/adesisServices.js";
import sendEventoGTM from "../../../utils/tags";

export default class CarFeatures extends Component {
  constructor() {
    super();
    this.state = {
      gearBoxNameOptions: [],
      engineNameOptions: [],
      yearOptions: [],
      distanceOptions: [],
      yearIntervalError: false

    };
    this.matchFullKatashiki = "";
    this.adesisServices = new adesisServices();
  }

  componentDidMount() {
    this.scrollToTop();
  }

  componentDidUpdate(prevProps) {
    if (!this.props.carInfo) {
      if (prevProps.fuelSelected !== this.props.fuelSelected) {
        this.setGearBoxNameOptions();
      }
      if (prevProps.gearBoxNameSelected !== this.props.gearBoxNameSelected) {
        this.setEngineNameOptions();
      }
      if (prevProps.engineNameSelected !== this.props.engineNameSelected) {
        this.setYearOptions();
      }
      if (prevProps.yearSelected !== this.props.yearSelected) {
        this.findCarByOptions();
        this.resetDistanceOptions();
      }

    }
  }

  componentWillMount() {
    this.props.fuelSelected && this.setGearBoxNameOptions();
    if (
      this.props.fuelSelected &&
      this.props.selectedModel.fuelTypes.length !== 1
    ) {
      setTimeout(() => {
        this.setGearBoxNameOptions();
      }, 800);
    }
    this.props.setAppBarState(2, 2, 1, 0);
    if (this.props.selectedModel) this.setOneModelCars();

    this.props.yearIntervalError && this.setState({ ...this.state, yearIntervalError: true })
  }

  scrollToTop = () => {
    if (window.innerWidth <= 425) {
      let elmnt = document.getElementById("features-title");
      elmnt && elmnt.scrollIntoView();
    }
  };

  ///LISTO PARA NUEVO SERVICIO
  setOneModelCars = () => {
    let rangeCodeSelected = this.props.selectedModel.rangeCode;
    let oneModelCars;
    let fullKatashikiArray = [];

    this.props.allCarsInfo.forEach((model, i) => {
      if (model.rangeCode === rangeCodeSelected) 
        oneModelCars = model.lst;

      // if (model.rangeCode === 30) 
      //  oneModelCars = model.lst;
    });

    console.log('oneModelCars: ', oneModelCars)

    oneModelCars = oneModelCars.filter(car => car.fullKatashiki);
    if (this.props.selectedModel.extraCondition) {
      oneModelCars = oneModelCars.filter(car => {
        return car.modelName
          .toLowerCase()
          .includes(this.props.selectedModel.extraCondition);
      });
    }

    if (this.props.selectedModel.fuelTypes.length === 1) {
      oneModelCars.forEach(car => {
        car.fuel = this.props.selectedModel.fuelTypes[0];
      });
    } else {
      oneModelCars.forEach(car => {
        if (!fullKatashikiArray.includes(car.fullKatashiki)) {
          fullKatashikiArray.push(car.fullKatashiki);
        }
      });
      this.adesisServices.getFuel(fullKatashikiArray).then(response => {
        oneModelCars.forEach(model => {
          response.data.Data.forEach(fuelType => {
            if (model.fullKatashiki === fuelType.sFullKatashiki) {
              model.fuel = fuelType.sCombustible;
            }
          });
        });
        oneModelCars = oneModelCars.filter(car => car.fuel);
      });
    }

    this.setState({
      ...this.state,
      oneModelCars
    });
  };

  // setOneModelCars = () => {
  //   let rangeCodeSelected = this.props.selectedModel.rangeCode;
  //   let oneModelCars;
  //   let fullKatashikiArray = [];
  //   this.props.allCarsInfo.forEach((model, i) => {
  //     if (model.rangeCode === rangeCodeSelected) oneModelCars = model.lst;
  //   });
  //   oneModelCars = oneModelCars.filter(car => car.fullKatashiki);
  //   if (this.props.selectedModel.extraCondition) {
  //     oneModelCars = oneModelCars.filter(car => {
  //       return car.modelName
  //         .toLowerCase()
  //         .includes(this.props.selectedModel.extraCondition);
  //     });
  //   }
  //   if (this.props.selectedModel.fuelTypes.length === 1) {
  //     oneModelCars.forEach(car => {
  //       car.fuel = this.props.selectedModel.fuelTypes[0];
  //     });
  //   } else {
  //     if (this.props.selectedModel.hasHybrid) {
  //       oneModelCars.forEach(car => {
  //         if (car.modelName.toLowerCase().includes("hybrid")) {
  //           car.fuel = "Híbrido";
  //         } else {
  //           if (!fullKatashikiArray.includes(car.fullKatashiki)) {
  //             fullKatashikiArray.push(car.fullKatashiki);
  //           }
  //         }
  //       });
  //       this.adesisServices.getFuel(fullKatashikiArray).then(response => {
  //         oneModelCars.forEach(model => {
  //           response.data.Data.forEach(fuelType => {
  //             if (model.fullKatashiki === fuelType.sFullKatashiki) {
  //               model.fuel = fuelType.sCombustible;
  //             }
  //           });
  //         });
  //         oneModelCars = oneModelCars.filter(car => car.fuel);
  //       });
  //     } else {
  //       oneModelCars.forEach(car => {
  //         if (!fullKatashikiArray.includes(car.fullKatashiki)) {
  //           fullKatashikiArray.push(car.fullKatashiki);
  //         }
  //       });

  //       this.adesisServices.getFuel(fullKatashikiArray).then(response => {
  //         oneModelCars.forEach(model => {
  //           response.data.Data.forEach(fuelType => {
  //             if (model.fullKatashiki === fuelType.sFullKatashiki) {
  //               model.fuel = fuelType.sCombustible;
  //             }
  //           });
  //         });
  //         oneModelCars = oneModelCars.filter(car => car.fuel);
  //       });
  //     }
  //   }

  //   this.setState({
  //     ...this.state,
  //     oneModelCars
  //   });
  // };

  setGearBoxNameOptions = () => {
    this.props.getCarFeaturesValues("gearBoxNameSelected", undefined);
    let gearBoxNameOptions = [];
    this.setState(
      { ...this.state, gearBoxNameOptions: [], distanceOptions: [] },
      () => {
        if (!this.props.gearBoxNameSelected) {
          this.state.oneModelCars.forEach(option => {
            console.log('gerabox: ', option.gearBoxName)
            if (
              !gearBoxNameOptions.includes(option.gearBoxName) &&
              option.fuel === this.props.fuelSelected &&
              this.props.selectedModel.fuelTypes.length !== 1
            ) {
              gearBoxNameOptions.push(option.gearBoxName);
            }
            if (
              !gearBoxNameOptions.includes(option.gearBoxName) &&
              this.props.selectedModel.fuelTypes.length === 1
            ) {
              gearBoxNameOptions.push(option.gearBoxName);
            }
          });
        }
        if (gearBoxNameOptions.length === 1) {
          this.props.getCarFeaturesValues(
            "gearBoxNameSelected",
            gearBoxNameOptions[0]
          );
        }
        this.setState({
          ...this.state,
          gearBoxNameOptions: gearBoxNameOptions.sort(),
          engineNameOptions: [],
          yearOptions: []
        });
      }
    );
  };

  setEngineNameOptions = () => {
    this.props.getCarFeaturesValues("engineNameSelected", undefined);
    let engineNameOptions = [];
    this.setState(
      { ...this.state, engineNameOptions: [], distanceOptions: [] },
      () => {
        if (!this.props.engineNameSelected && this.props.gearBoxNameSelected) {
          this.state.oneModelCars.forEach(option => {
            if (
              option.fuel === this.props.fuelSelected &&
              option.gearBoxName === this.props.gearBoxNameSelected &&
              !engineNameOptions.includes(option.engineName) &&
              this.props.selectedModel.fuelTypes.length !== 1
            ) {
              engineNameOptions.push(option.engineName);
            }
            if (
              option.gearBoxName === this.props.gearBoxNameSelected &&
              !engineNameOptions.includes(option.engineName) &&
              this.props.selectedModel.fuelTypes.length === 1
            ) {
              engineNameOptions.push(option.engineName);
            }
          });
        }
        if (engineNameOptions.length === 1) {
          this.props.getCarFeaturesValues(
            "engineNameSelected",
            engineNameOptions[0]
          );
        }
        this.setState({
          ...this.state,
          engineNameOptions: engineNameOptions.sort(),
          yearOptions: [],
          yearIntervalError: false
        });
      }
    );
  };

  setYearOptions = () => {
    this.props.getCarFeaturesValues("yearSelected", undefined);
    let yearOptions = [];
    this.setState(
      {
        ...this.state,
        yearOptions: [],
        distanceOptions: [],
        yearIntervalError: false
      },
      () => {
        if (
          !this.props.yearSelected &&
          this.props.gearBoxNameSelected &&
          this.props.engineNameSelected
        ) {
          this.state.oneModelCars.forEach(option => {
            if (
              option.fuel === this.props.fuelSelected &&
              option.engineName === this.props.engineNameSelected &&
              option.gearBoxName === this.props.gearBoxNameSelected &&
              !yearOptions.includes(option.year) &&
              this.props.selectedModel.fuelTypes.length !== 1
            ) {
              yearOptions.push(option.year);
            }
            if (
              option.engineName === this.props.engineNameSelected &&
              option.gearBoxName === this.props.gearBoxNameSelected &&
              !yearOptions.includes(option.year) &&
              this.props.selectedModel.fuelTypes.length === 1
            ) {
              yearOptions.push(option.year);
            }
          });
        }
        if (yearOptions.length === 1) {
          this.props.getCarFeaturesValues("yearSelected", yearOptions[0]);
        }
        this.setState({
          ...this.state,
          yearOptions: yearOptions.sort()
        });
      }
    );
  };

  getSelectValue = e => {
    const { value } = e.target;
    const { name } = e.target;
    this.props.getCarFeaturesValues(name, value);
    if (name === "distanceSelected") {
      setTimeout(() => {
        this.getBudeget();
      }, 300);
    }
  };

  findCarByOptions = () => {
    if (
      this.props.fuelSelected &&
      this.props.gearBoxNameSelected &&
      this.props.engineNameSelected &&
      this.props.yearSelected
    ) {
      this.state.oneModelCars.forEach(car => {
        if (
          car.fuel === this.props.fuelSelected &&
          car.gearBoxName === this.props.gearBoxNameSelected &&
          car.engineName === this.props.engineNameSelected &&
          car.year === this.props.yearSelected
        ) {
          this.matchFullKatashiki = car.fullKatashiki;
        }
      });
    }
    this.getKmInterval();
  };

  resetDistanceOptions = () => {
    this.setState({ ...this.state, yearIntervalError: false, distanceOptions: [] }, () => {
      this.props.getCarFeaturesValues("distanceSelected", undefined);
    });
  };

  getKmInterval = () => {
    this.setState({ ...this.state, distanceOptions: [] }, () => {
      if (this.props.yearSelected && this.props.gearBoxNameSelected) {
        console.log("this.props before call getKmMantenimiento", this.props);
        this.adesisServices
          .getKmMantenimiento(
            // this.matchFullKatashiki[0],
            this.matchFullKatashiki,
            this.props.gearBoxNameSelected,
            this.props.yearSelected,
            this.props.engineNameSelected
          )
          .then(response => {
            let yearInterval = response.data.Data;
            if (yearInterval === "") {
              this.setState({ ...this.state, yearIntervalError: true });
            } else {
              yearInterval = parseInt(yearInterval);
              let distanceOptions = [];
              for (let i = 0; i < 16; i++) {
                i === 0
                  ? distanceOptions.push(`${yearInterval}.000 km o 1 año`)
                  : distanceOptions.push(
                    `${(i + 1) * yearInterval}.000 km o ${i + 1} años`
                  );
              }
              this.setState({ ...this.state, distanceOptions });
            }
          });
      }
    });
  };

  getBudeget = () => {
    console.log('selectedWorkshops: ', this.props.selectedWorkshops)
    this.props.carInfo
      ? this.adesisServices
        .getBudeget(
          // this.matchFullKatashiki[0],
          this.props.carInfo.fullKatashiki,
          this.props.carInfo.year,
          this.props.carInfo.gearBoxName,
          // this.props.selectedWorkshops.nIdConcesionario,
          // this.props.selectedWorkshops.nIdLocalizacion,
          this.props.selectedWorkshops.unitHourPrice,
          parseInt(this.props.distanceSelected),
          this.props.carInfo.fuel,
          this.props.carInfo.engineName
        )
        .then(response => {
          this.props.getBudgetToApp(response.data.Data);
        })
      : this.adesisServices
        .getBudeget(
          // this.matchFullKatashiki[0],
          this.matchFullKatashiki,
          this.props.yearSelected,
          this.props.gearBoxNameSelected,
          // this.props.selectedWorkshops.nIdConcesionario,
          // this.props.selectedWorkshops.nIdLocalizacion,
          this.props.selectedWorkshops.unitHourPrice,
          parseInt(this.props.distanceSelected),
          this.props.fuelSelected,
          this.props.engineNameSelected
        )
        .then(response => {
          this.props.getBudgetToApp(response.data.Data);
        });
  };

  buscadorConcesionadioRedirect = () => {
    window.open(
      "https://www.lexusauto.es/concesionarios"
      // "https://www.toyota.es/#/ajax/%2Fforms%2Fforms%3Ftab%3Dpane-dealer%26showAllResults%3Dtrue"
    );
  };

  render() {
    return this.props.selectedModel ? (
      <div>
        <div className="container-fluid" id="features-title">
          <div className="row">
            <div className="col-12">
              <div className="title">
                <h3 className="small-title text-center">
                  Introduce los datos de tu Lexus
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div className="smaller form-container">
          <form>
            <div className="car-features-panes-container container-with-margin container-with-margin-right">
              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                  <div className="form-pane">
                    <div className="number-container">
                      <div className="number-content">
                        <span>1</span>
                        <div className="active">
                          {/* <img src="./images/Ico-Check.png" alt="ico-check" /> */}
                          <img src="./images/accept.png" style={{ width: 26 }} alt="ico-check" />
                        </div>
                      </div>
                    </div>
                    <div className="image-container">
                      <img
                        id="car-photo"
                        src={this.props.selectedModel.image}
                        alt="imagen-coche"
                      />
                    </div>
                    <div className="text-container model-text-container" style={{ marginTop: 0 }}>
                      {this.props.selectedModel.nameCase}
                    </div>
                    <div className="control-container first">
                      <Link to="/modelSelector" style={{ display: "flex", alignItems: "center", justifyContent: "center", textDecoration: "none" }}>
                        {/* <button
                          onClick={this.props.resetRedirect}
                          className="mm-button mm-block mm-rounded mm-black"
                        >
                          Cambiar modelo
                        </button> */}
                        {/* <button class="button_mostrar_mas btn-descubrir" type="button" onClick={this.props.resetRedirect}>
                          <span class="btn-vehiculos" style={{ marginLeft: 5 }}>
                            CAMBIAR MODELO
                          </span>
                          <span class="linea-boton"></span>
                        </button> */}

                        <button class="button_mostrar_mas btn-descubrir" style={{ marginTop: 10 }} type="button" onClick={ this.props.resetRedirect }>
                          <span class="btn-vehiculos">
                            CAMBIAR MODELO
                          </span>
                          <span class="linea-boton"></span>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>

                <div
                  id="fuell-scroll"
                  className="col-sm-12 col-md-6 col-lg-6 col-xl-4"
                >
                  <div className="form-pane with-buttons">
                    <div className="number-container">
                      <div className="number-content">
                        <span>2</span>
                        {this.props.fuelSelected || this.props.carInfo ? (
                          <div className="active">
                            {/* <img src="./images/Ico-Check.png" alt="ico-check" /> */}
                            {/* <img src="./images/check-blue.png" style={{ width: 26 }} alt="ico-check" /> */}
                            <img src="./images/accept.png" style={{ width: 26 }} alt="ico-check" />
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="image-container">
                      <img src="./images/surtidor.png" alt="imagen" />
                    </div>
                    <div className="text-container">Combustible</div>
                    {!this.props.carInfo ? (
                      <Select
                        name="fuelSelected"
                        values={this.props.selectedModel.fuelTypes}
                        getSelectValue={this.getSelectValue}
                        selectedValue={this.props.fuelSelected}
                      />
                    ) : (
                      <Select
                        name="fuelSelected"
                        values={[]}
                        getSelectValue={this.getSelectValue}
                        carInfo={this.props.carInfo.fuel}
                      />
                    )}
                  </div>
                </div>

                <div
                  id="gear-scroll"
                  className="col-sm-12 col-md-6 col-lg-6 col-xl-4"
                >
                  <div className="form-pane with-buttons">
                    <div className="number-container">
                      <div className="number-content">
                        <span>3</span>
                        {this.props.gearBoxNameSelected ||
                          this.props.carInfo ? (
                          <div className="active">
                            {/* <img src="./images/Ico-Check.png" alt="ico-check" /> */}
                            {/* <img src="./images/check-blue.png" style={{ width: 26 }} alt="ico-check" /> */}
                            <img src="./images/accept.png" style={{ width: 26 }} alt="ico-check" />
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="image-container">
                      <img src="./images/marchas.png" alt="imagen" />
                    </div>
                    <div className="text-container">Tipo de cambio</div>
                    {!this.props.carInfo ? (
                      <Select
                        name="gearBoxNameSelected"
                        values={this.state.gearBoxNameOptions}
                        getSelectValue={this.getSelectValue}
                        selectedValue={this.props.gearBoxNameSelected}
                      />
                    ) : (
                      <Select
                        name="gearBoxNameSelected"
                        carInfo={this.props.carInfo.gearBoxName}
                        values={[]}
                        getSelectValue={this.getSelectValue}
                      />
                    )}
                  </div>
                </div>

                <div
                  id="engine-scroll"
                  className="col-sm-12 col-md-6 col-lg-6 col-xl-4"
                >
                  <div className="form-pane">
                    <div className="number-container">
                      <div className="number-content">
                        <span>4</span>
                        {this.props.engineNameSelected || this.props.carInfo ? (
                          <div className="active">
                            {/* <img src="./images/Ico-Check.png" alt="ico-check" /> */}
                            {/* <img src="./images/check-blue.png" style={{ width: 26 }} alt="ico-check" /> */}
                            <img src="./images/accept.png" style={{ width: 26 }} alt="ico-check" />
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="image-container">
                      <img src="./images/motor.png" alt="imagen" />
                    </div>
                    <div className="text-container">Motor</div>
                    {!this.props.carInfo ? (
                      <Select
                        name="engineNameSelected"
                        values={this.state.engineNameOptions}
                        getSelectValue={this.getSelectValue}
                        selectedValue={this.props.engineNameSelected}
                      />
                    ) : (
                      <Select
                        name="gearBoxNameSelected"
                        carInfo={this.props.carInfo.engineName}
                        values={[]}
                        getSelectValue={this.getSelectValue}
                      />
                    )}
                  </div>
                </div>

                <div
                  id="year-scroll"
                  className="col-sm-12 col-md-6 col-lg-6 col-xl-4"
                >
                  <div className="form-pane with-buttons">
                    <div className="number-container">
                      <div className="number-content">
                        <span>5</span>
                        {this.props.yearSelected || this.props.carInfo ? (
                          <div className="active">
                            {/* <img src="./images/Ico-Check.png" alt="ico-check" /> */}
                            {/* <img src="./images/check-blue.png" style={{ width: 26 }} alt="ico-check" /> */}
                            <img src="./images/accept.png" style={{ width: 26 }} alt="ico-check" />
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="image-container">
                      <img src="./images/calendar.png" alt="imagen" />
                    </div>
                    <div id="year-scroll" className="text-container">
                      Año de producción
                    </div>
                    {!this.props.carInfo ? (
                      <Select
                        name="yearSelected"
                        values={this.state.yearOptions}
                        getSelectValue={this.getSelectValue}
                        selectedValue={this.props.yearSelected}
                      />
                    ) : (
                      <Select
                        name="yearSelected"
                        carInfo={this.props.carInfo.year}
                        values={[]}
                        getSelectValue={this.getSelectValue}
                      />
                    )}
                  </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                  {!this.state.yearIntervalError ? (
                    <div className="form-pane with-buttons">
                      <div className="number-container">
                        <div className="number-content">
                          <span>6</span>
                          {this.props.distanceSelected ? (
                            <div className="active">
                              {/* <img
                                src="./images/Ico-Check.png"
                                alt="ico-check"
                              /> */}
                              {/* <img src="./images/check-blue.png" style={{ width: 26 }} alt="ico-check" /> */}
                              <img src="./images/accept.png" style={{ width: 26 }} alt="ico-check" />
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="image-container">
                        <img src="./images/todolist.png" alt="imagen" />
                      </div>
                      <div className="text-container">
                        Años o Nº de kilómetros
                        <p className="copy-km">(Lo que antes suceda)</p>
                      </div>

                      <Select
                        name="distanceSelected"
                        values={

                          this.props.distanceOptions
                            ? (this.props.selectedModel.rangeCode != 17 ? this.props.distanceOptions : this.props.distanceOptions.slice(1))
                            : (this.props.selectedModel.rangeCode != 17 ? this.state.distanceOptions : this.state.distanceOptions.slice(1))
                        }
                        getSelectValue={this.getSelectValue}
                      />
                    </div>
                  ) : (
                    <div className="form-pane with-buttons">
                      <p className="error-km-interval-red">
                        Lo sentimos, en este momento no podemos mostrarte un presupuesto estimado de mantenimiento para el vehículo seleccionado.
                      </p>
                      <p className="error-km-interval-black">
                        Por favor,{" "}
                        <b>
                          ponte en contacto con tu concesionario más cercano
                        </b>
                        .
                      </p>
                      {/* <button
                        onClick={this.buscadorConcesionadioRedirect}
                        className="mm-button mm-rounded mm-red error-btn">Solicitar cita al concesionario</button> */}
                      <button class="button_mostrar_mas btn-descubrir" type="button" style={{ margin: 0 }} onClick={this.buscadorConcesionadioRedirect}>
                        <span class="btn-vehiculos" style={{ marginLeft: 5 }}>
                          SOLICITAR CITA AL CONCESIONARIO
                        </span>
                        <span class="linea-boton"></span>
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="button-container">
                  {/* <button
                    type="button"
                    className={`mm-button mm-rounded mm-red ${(this.props.fuelSelected &&
                        this.props.gearBoxNameSelected &&
                        this.props.engineNameSelected &&
                        this.props.yearSelected &&
                        this.props.distanceSelected) ||
                        (this.props.carInfo && this.props.distanceSelected)
                        ? ""
                        : "disabled"
                      }`}
                    onClick={() => {
                      this.props.distanceSelected &&
                        this.props.showLastStepsToggle();
                      this.props.carInfo
                        ? sendEventoGTM(
                          "5-calculation-license-plate-submitted",
                            "1"
                        )
                        : // Calculation Model Selected
                        sendEventoGTM(
                          "5-calculation-model-selected",
                            "1"
                        );
                    }}
                  >
                    Calcular presupuesto
                  </button> */}

                  {/* <button className="button_mostrar_mas btn-descubrir" style={{ marginTop: 10, width: 250 }} type="button" onClick={() => { */}
                  <button className="button_mostrar_mas btn-descubrir" style={{ marginTop: 10, width: 250 }} type="button" disabled={
                        (this.props.gearBoxNameSelected &&
                        this.props.engineNameSelected &&
                        this.props.yearSelected &&
                        this.props.distanceSelected) ||
                        (this.props.carInfo && this.props.distanceSelected)
                        ? false : true}
                      onClick={() => {
                      this.props.distanceSelected &&
                        this.props.showLastStepsToggle();
                      this.props.carInfo
                        ? sendEventoGTM(
                          "5-calculation-license-plate-submitted",
                            "1"
                        )
                        : // Calculation Model Selected
                        sendEventoGTM(
                          "5-calculation-model-selected",
                            "1"
                        );
                    }}>
                    <span class="btn-vehiculos">
                      CALCULAR PRESUPUESTO
                    </span>
                    <span class="linea-boton"></span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    ) : null;
  }
}
